module.exports = __webpack_public_path__ + "static/media/scoring.88a20052.png";